import * as regionsKeyset from 'i18n/Region';

const YANDEX_COUNTRIES_LIST: (keyof (typeof regionsKeyset)['en'])[] = ['RU', 'KZ', 'BY', 'UZ', 'AZ'];
export const YANDEX_COUNTRIES_SET = new Set(YANDEX_COUNTRIES_LIST);
